import type {ReactElement} from 'react';
import React from 'react';
import useDefaultPanelClose from '@Panels/hooks/useDefaultPanelClose';
import {Panel, PanelHeader} from '@Components/panel';
import {DrawBrushSizeOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/draw-brush-size-option';

interface PosterEditorDrawBrushSizePanelProps {
  panelId: string;
}

export default function PosterEditorDrawBrushSizePanel({...props}: PosterEditorDrawBrushSizePanelProps): ReactElement {
  const onClose = useDefaultPanelClose(props.panelId);

  const getHeader = (): ReactElement => {
    return <PanelHeader onClose={onClose} title={window.i18next.t('pmwjs_brush_size')} />;
  };

  const getContent = (): ReactElement => {
    return (
      <div className="spacing-p-t-2 spacing-p-b-6 spacing-p-r-6 spacing-p-l-6">
        <DrawBrushSizeOption />
      </div>
    );
  };

  return <Panel panelHeader={getHeader()} panelContent={getContent()} />;
}
